enum WarrantySelectionEnum {
  OneYear = 'one-year',
  TwoYear = 'two-year',
  ThreeYear = 'three-year',
}

export default WarrantySelectionEnum;
